export default __webpack_public_path__ + "static/media/product-availability.edb69643.svg";